import React from 'react'

import Base from '../_Base'

const StarFilled = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <polygon points="15.266 8.352 11.9878699 1.7230412 8.73 8.352 1.43129568 9.3974016 6.71 14.528 5.4647669 21.848604 11.999 18.39 18.5439334 21.8495737 17.285 14.528 22.570262 9.39753908" />
  </Base>
)

export default StarFilled
